import React from 'react'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

const tagContainerHeight = 21
const tagContainerBorderWidth = 1
const tagContainerLeftPadding = 4
const tagCornerSize = Math.round(
  (tagContainerHeight - 2 * tagContainerBorderWidth) / Math.sqrt(2)
)
const tagCornerTranslateX = -Math.round(
  tagContainerLeftPadding + (tagContainerBorderWidth + tagCornerSize) / 2
)

const tagContainerCss = css`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  align-content: center;
  position: relative;
  min-width: 0;
  padding: 0 6px 0 ${tagContainerLeftPadding}px;
  margin-right: 3px;
  margin-left: ${tagContainerHeight / 3}px;
  height: ${tagContainerHeight}px;
  border-radius: 3px;
  background-color: ${theme.color.white};
  border: ${tagContainerBorderWidth}px solid ${theme.color.neutral30};
  font-size: 12px;

  :last-child {
    margin-right: 0;
  }

  :before {
    position: absolute;
    background-color: ${theme.color.white};
    content: '';
    height: ${tagCornerSize}px;
    width: ${tagCornerSize}px;
    transform: translateX(${tagCornerTranslateX}px) rotate(45deg);
    border: ${tagContainerBorderWidth}px solid ${theme.color.neutral30};
    border-top: none;
    border-right: none;
    top: 3px;
  }
`

interface Props {
  readonly onClick?: () => void
  readonly children?: React.ReactNode
  readonly innerRef?: (ref: any) => void
  readonly className?: string
}

export function TagContainer({
  innerRef,
  className,
  onClick,
  children
}: Props) {
  return (
    <div
      className={cx(tagContainerCss, className)}
      data-testid="tag-container"
      ref={innerRef}
      onClick={onClick}
      children={children}
    />
  )
}
